import React from "react";
import { Card, CardHeader, CardBody, Table } from "reactstrap";

const cardShell = {
  background: "var(--vz-secondary-bg, #fff)",
  border: "1px solid var(--vz-border-color)",
  borderRadius: 10,
  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  overflow: "hidden",
};

const pageIconWrapStyle = {
  width: 32,
  height: 32,
  borderRadius: 8,
  border: "1px solid rgba(var(--vz-primary-rgb), 0.35)",
  background: "rgba(var(--vz-primary-rgb), 0.08)",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const pageIconStyle = {
  color: "var(--vz-primary)",
  fontSize: 16,
};


const alerts = [
  {
    time: "14:22:05",
    alert: "Unauthorized Modbus Write Command to PLC_04",
    severity: "Critical",
    source: "Eng_Workstation_2"
  },
  {
    time: "14:18:12",
    alert: "Suspicious Lateral Movement: HMI_North to Historian",
    severity: "High",
    source: "Internal_Net"
  },
  {
    time: "14:05:45",
    alert: "Outdated Firmware Detected on Siemens S7-1500",
    severity: "Medium",
    source: "Asset_Discovery"
  },
  {
    time: "13:55:01",
    alert: "Multiple Failed Auth Attempts: Admin account",
    severity: "High",
    source: "Remote_VPN"
  },
  {
    time: "13:42:30",
    alert: "Unknown Protocol Usage (DNP3 Variant) on Port 20000",
    severity: "Medium",
    source: "Edge_Router"
  }
];

const severityColor = {
  Critical: "#ef4444",
  High: "#f97316",
  Medium: "#facc15"
};

const OTSecurityAlertsFeed = () => {
  return (
    <Card style={{...cardShell, border: "1px solid rgba(255,255,255,0.05)" }} className="h-100">

      {/* Header */}
      <CardHeader className="bg-light d-flex justify-content-between align-items-center">

        <div>
          <h5 className="card-title mb-1">
            <div style={pageIconWrapStyle} className="me-2">
              <i className=" ri-notification-3-line " style={pageIconStyle} ></i>
            </div>
            OT Security Alerts Feed
          </h5>

          <small className="text-muted">
            Live chronological incident stream from intrusion detection systems.
          </small>
        </div>

        <button
          className="btn btn-sm"
          style={{
            border: "1px solid rgba(255,255,255,0.15)",
            color: "#f97316"
          }}
        >
          <i className="ri-download-line me-1"></i>
          Export CSV
        </button>

      </CardHeader>

      {/* Table */}
      <CardBody>

        <div className="table-responsive">

          <Table hover className="align-middle mb-0">

            <thead
              style={{
                borderBottom: "1px solid rgba(255,255,255,0.05)",
                fontSize: "12px"
              }}
              className="text-muted"
            >
              <tr>
                <th>TIMESTAMP</th>
                <th>SECURITY ALERT</th>
                <th>SEVERITY</th>
                <th>INCIDENT SOURCE</th>
                <th className="text-end">ACTIONS</th>
              </tr>
            </thead>

            <tbody>

              {alerts.map((item, index) => (
                <tr
                  key={index}
                  style={{
                    borderBottom: "1px solid rgba(255,255,255,0.03)"
                  }}
                >

                  <td>{item.time}</td>

                  <td style={{ fontWeight: 500 }}>
                    {item.alert}
                  </td>

                  <td>

                    <span className="d-flex align-items-center">

                      <span
                        style={{
                          width: 8,
                          height: 8,
                          borderRadius: "50%",
                          background: severityColor[item.severity],
                          marginRight: 8
                        }}
                      />

                      {item.severity}

                    </span>

                  </td>

                  <td className="text-muted">
                    {item.source}
                  </td>

                  <td className="text-end">

                    <button
                      className="btn btn-sm"
                      style={{
                        border: "1px solid rgba(249,115,22,0.35)",
                        color: "#f97316"
                      }}
                    >
                      Investigate
                    </button>

                  </td>

                </tr>
              ))}

            </tbody>

          </Table>

        </div>

      </CardBody>

    </Card>
  );
};

export default OTSecurityAlertsFeed;